module.exports = __webpack_public_path__ + "static/media/honour1.d20c6f81.png";